import React from "react";
import {Link} from "react-router-dom";
import Home from "../../img/Home.png";
import MyBooks from "../../img/MyBooks.png";
import MyBooklists from "../../img/MyBooklists.png";
import AllOptions from "../../img/AllOptions.png";
import BookWhite from "../../img/BookWhite.png";
import CreateBookListIK from "../../img/CreateBookListIK.png";

class MenuBar extends React.Component{
    constructor(props) {
      super(props);
      
      if(props.url.includes("/main/books")){
        this.state = {
          "active": "My Books",
          "createActive": false
        };
      }else if(props.url.includes("/main/bookLists")){
        this.state = {
          "active": "My Booklists",
          "createActive": false
        };
      }else if(props.url.includes("/main/allOptions")){
        this.state = {
          "active": "All Options",
          "createActive": false
        };
      }else if(props.url.includes("/main/createBook")){
        this.state = {
          "active": "Create Book",
          "createActive": false
        };
      }
      else if(props.url.includes("/main/createBookList")){
        this.state = {
          "active": "Create Book List",
          "createActive": false
        };
      }else if(props.url.includes("/main/editProfile")){
        this.state = {
          "active": "Edit Profile",
          "createActive": false
        };
      }else if(props.url.includes("/main/editBookl")){
        this.state = {
          "active": "My Booklists",
          "createActive": false
        };
      }else if(props.url.includes("/main/editBook")){
        this.state = {
          "active": "My Books",
          "createActive": false
        };
      }else if(props.url.includes("/main/alterBooks")){
        this.state = {
          "active": "My Booklists",
          "createActive": false
        };
      }else{
        this.state = {
          "active": "Dashboard",
          "createActive": false
        };
      }
    
    }
    clickD = () => {
        this.setState({"active": "Dashboard"});
    };
    clickMb = () => {
        this.setState({"active": "My Books"});
    };
    clickMbl = () => {
        this.setState({"active": "My Booklists"});
    };

    clickAll = () => {
        this.setState({"active": "All Options"});
    };

    createActive = () => {
        this.setState({"createActive": true});
    };
    createNActive = () => {
        this.setState({"createActive": false});
    };
    aCreateBook = () => {
        this.setState({"active": "Create Book", "createActive": false})
    }
    render(){
        return(
            <div>
                <div className="menu_bar_buttons">
                    <Link to="/main"
                    className={(this.state.active === "Dashboard") ? "menu_bar_button active"
                    :"menu_bar_button"}
                     onClick={this.clickD}>
                        <img 
                            src={Home} 
                            alt="Dashboard" 
                            className="menu_bar_button_icon"
                        />
                        <h6 className="menu_bar_button_text">Dashboard</h6>
                    </Link>
                    <Link to="/main/books" className={(this.state.active === "My Books") ? "menu_bar_button active"
                    :"menu_bar_button"} onClick={this.clickMb}>
                        <img 
                            src={MyBooks} 
                            alt="Dashboard" 
                            className="menu_bar_button_icon"
                        />
                        <h6 className="menu_bar_button_text">My Books</h6>
                    </Link>
                    <Link to="/main/bookLists" className={(this.state.active === "My Booklists") ? "menu_bar_button active"
                    :"menu_bar_button"} onClick={this.clickMbl}>
                        <img 
                            src={MyBooklists} 
                            alt="Dashboard" 
                            className="menu_bar_button_icon"
                        />
                        <h6 className="menu_bar_button_text">My Booklists</h6>
                    </Link>
                    <Link to="/main/allOptions" className={(this.state.active === "All Options") ? "menu_bar_button active"
                    :"menu_bar_button"} onClick={this.clickAll}>
                        <img 
                            src={AllOptions} 
                            alt="Dashboard" 
                            className="menu_bar_button_icon"
                        />
                        <h6 className="menu_bar_button_text">All Options</h6>
                    </Link>
                </div>

                <div className="createBookIconReadBook">
                        {this.state.active !== "Create Book" && ( 
                        <div>
                            {!this.state.createActive && (
                            <h1 className="createIcon" onClick={this.createActive}>
                             + 
                            </h1>  
                            )}
                            {this.state.createActive && (
                                <div>
                                    <div className="createOv" onClick={this.createNActive}>
                                    </div>
                                    <div id="createBookList">
                                    <Link to="/main/createBookList" id="createBook" onClick={this.aCreateBook}>
                                    <div className="createBookListIcon">
                                        <img src={CreateBookListIK} alt="B" />
                                    </div> 
                                    </Link>
                                    <h1 id="text2"> Create Booklist </h1>
                                    </div>
                                    <Link to="/main/createBook" id="createBook" onClick={this.aCreateBook}>
                                    <div className="createBookIcon">
                                        <img src={BookWhite} alt="B" />
                                    </div> 
                                    <h1 id="text"> Create Book </h1>
                                    </Link>
                                </div>
                            )}  
                        </div>
                        )}
                </div>
            </div>
        );
    };
};

export default MenuBar;

